import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";

import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";

import Footer from "./components/footer";
import InterviewListPage from "./interview/interview-list-page";
import InterviewSuccessPage from "./interview/interview-success-page";
import SubmitForm from "./SubmitForm";

function App() {
  return (
    <Router>
      <div className="App">
        {/* thêm logo 4handy HR */}
        <img
          src="/logo-4handy.png"
          alt="4handy HR"
          className="logo"
          style={{
            width: "120px",
            margin: "0 auto",
            display: "block",
            marginTop: "30px",
            marginBottom: "10px",
          }}
        />
        <h1 className="text-4xl font-bold mb-4 text-center">Human Resources</h1>
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="/interview/list" element={<InterviewListPage />} />
          <Route path="/interview/success" element={<InterviewSuccessPage />} />
        </Routes>
        <ToastContainer />
        <Footer />
      </div>
    </Router>
  );
}

const MainPage: React.FC = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const applicationFormId = query.get("formId");
  const errorText =
    " Không có thông tin hồ sơ tương ứng, vui lòng kiểm tra lại";
  if (!applicationFormId) {
    toast.error(errorText);
    return <div className="text-center mt-4 text-danger">{errorText}</div>;
  }

  return <SubmitForm applicationFormId={applicationFormId} />;
};

export default App;
